import React, {useState} from 'react'

import { useNavigate } from 'react-router-dom';


import imageOne from '../resource/gallery/F29 (2).png'
import imageOtwo from '../resource/gallery/F29.png'
import imageThree from '../resource/gallery/F30.png'

import imageFive from '../resource/gallery/5.png'
import imageSix from '../resource/gallery/6.png'

import imageNine from '../resource/gallery/F28.png'

const Gallery = () => {
    const navigate = useNavigate();

    
        const handleClick = (event) => {
    
        const pathMap = {
            photoGallery:"/photoGallery",
          dhammasermons : "/dhammasermons",
          }
    
          const path = event.currentTarget.id;
          const targetPath = pathMap[path]
    
          if (targetPath) {
              navigate(targetPath)
          }
        }
    return (
        <div className="page gallery-page">
            <img src={imageOne} alt="" className="left-imge" />
            <img src={imageOtwo} alt="" className="right-imge" />



            <header>
                <div className="home-icon">
                    {/* <img src="#" alt="Home Icon"> */}
                </div>
                <div className="title">
                    <h1>Photo & Video Gallery</h1>
                    <img src={imageThree} width={400} />
                </div>
            </header>

            <div className="poem">
                <div >
                    <p>Enjoy the memories</p>
                    <p>From the day it starts</p>
                    <p>Meritorious deeds</p>
                    <p>Peaceful retreats</p>
                    <p>Share our happiness</p>
                </div>
                <div className='second-list'>
                    <p>Through the images</p>
                    <p>The hermitage serene</p>
                    <p>Auspicious events</p>
                    <p>The goodness we gain</p>
                    <p>With Sadhu! Anumodana!</p>
                </div>
            </div>


            <section className="button-section-hermitage">
                <div className="left-col">
                    <img src={imageFive} alt="" width={300} id='photoGallery' onClick={handleClick}/>
                    <img src={imageSix} alt="" width={300} />
                </div>



            </section>

            <div className="box">
                <img src={imageNine} alt="" className="bottom-imge" />
            </div>
        </div>
    )
}

export default Gallery